import { getMonthlyIncome } from 'app/pages/loanApplication/tabs/financialInfo/UpdateTableModal/Content/SectionContent/EmploymentAndIncome/EmploymentAndIncome.utils';
import { createSelector } from 'reselect';

import { incomeTypeMilitaryOptions, incomeTypesOptions } from 'constants/options';
import { getEmploymentStatus } from 'utils/loanApplication';

import { selectSortedCountiesByStates } from './counties.selectors';
import { selectLoanApplication } from './loanApplication.selectors';

const selectIncomes = createSelector(selectLoanApplication, ({ incomes }) => incomes);

// TODO: US12490 - revert this commit when this bug is fixed (Apply Team has to fix this issue on their side)
const selectIncomeValues = createSelector(
  [selectIncomes, selectSortedCountiesByStates],
  (incomes, counties) =>
    Object.values(incomes).map(income => {
      const state = income.workAddress?.state;
      const county = income.workAddress?.county;

      return {
        ...income,
        employmentStatus: getEmploymentStatus(income),
        workAddress: {
          ...income.workAddress,
          county: counties[state]?.find(({ value }) => value.startsWith(county))?.value,
        },
      };
    }),
  //TODO: remove County find when Apply and AdminPanel start using the same County format
);

export const selectIncomesWithTypeAndAmount = createSelector(selectIncomeValues, incomes =>
  incomes.map(income => {
    const monthlyIncome = getMonthlyIncome(income);
    const incomeTypeName = [...incomeTypesOptions, ...incomeTypeMilitaryOptions].find(
      ({ value }) => value === income.incomeType,
    )?.name;

    return {
      ...income,
      typeAndAmount: `${incomeTypeName} $${monthlyIncome}`,
    };
  }),
);
